
















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { GasyaResultUnit } from "@/constants";
import AwaikenUnitTextComponent from "@/components/AwaikenUnitTextComponent.vue";

@Component({
  components: {
    AwaikenUnitTextComponent,
  },
})
export default class AwaikenUnitComponent extends Vue {
  @Prop() unit!: GasyaResultUnit;
  @Prop() awaikingNum!: number;
  readonly w = 792;
  readonly h = 792 * 1.5;
  get tdStyle(): { background: string } {
    return {
      background: `url(${this.unit.pictureurl}) center center / contain no-repeat`,
    };
  }
  @Watch("unit")
  changeUnit() {
    (this.$refs.img as HTMLElement)?.classList?.add("img-anime");
  }
  endanime() {
    (this.$refs.img as HTMLElement)?.classList?.remove("img-anime");
  }
  done() {
    this.$emit("done");
  }
}
